import { Component, OnInit, Input } from '@angular/core';
import { IPropertyUnitGroupSpaces } from '../../../core/interfaces/property';

@Component({
  selector: 'app-suite-info',
  templateUrl: './suite-info.component.html',
  styleUrls: ['./suite-info.component.scss'],
  standalone: false
})
export class SuiteInfoComponent implements OnInit {
  @Input() additionalClass: string;
  @Input() name: string;
  @Input() adults: number;
  @Input() children: number;
  @Input() maxGuests: number;
  @Input() showMaxGuestsIcon: boolean;
  @Input() spaces: Array<IPropertyUnitGroupSpaces>;

  constructor() {}

  ngOnInit(): void {}
}
